export default __webpack_public_path__ + "images/trashRed.v-da82bd252559d2e212485a01b48aba6a.svg";